import { usePanachagesStore } from "@/store/panachages";
import { mapState } from "pinia";

export const useNavigationPagesStructuredData = (breadcrumbs) => {

  const head = () => {
    return {
      __dangerouslyDisableSanitizers: ["script"],
      script: [
        breadcrumbs && breadcrumbs.length > 0 && {
          innerHTML: JSON.stringify(structuredData),
          type: "application/ld+json"
        }
      ]
    }
  }

  const structuredBreadcrumbListData = () => {
    const breadcrumbList = []
    breadcrumbs && breadcrumbs.map((item, index) => {
      const url = typeof item.slug !== "undefined" ? item.slug : item.route
      const name = typeof item.title !== "undefined" ? item.title : item.text
      breadcrumbList.push(
        {
          "@type": "ListItem",
          position: index,
          name,
          item: "https://www.cora.fr" + url
        }
      )
    })
    return breadcrumbList
  }

  const structuredBreadcrumbsData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: structuredBreadcrumbListData()
  }

  const structuredData = [structuredBreadcrumbsData];

  return {
    structuredBreadcrumbsData,
    head
  }

}